import React, { forwardRef, useImperativeHandle, useRef, useState } from "react"
import Api from "../../../../_helpers/Api"
import { trans } from "../../../../_providers/Translation"
import Warranty from "../list/Warranty"
import ActivateWarranty from "../list/ActivateWarranty"
import Question from "../../../modals/messages/Question"
import Success from "../../../modals/messages/Success"
import { Tab, Tabs } from "@mui/material"
import GuaranteesList from "./GuaranteesList"
import ServicingList from "./ServicingList"
import WarrantyServicing from "../list/WarrantyServicing"

function Index(props, ref) {
  const warrantyModalRef = useRef(null)
  const activateWarrantyModalRef = useRef(null)
  const deleteModalRef = useRef(null)
  const successModalRef = useRef(null)
  const servicingModalRef = useRef(null)

  const [activeTab, setActiveTab] = useState(1)
  const [refresh, setRefresh] = useState(0)

  useImperativeHandle(ref, () => ({}))

  const triggerRefresh = () => {
    setRefresh((prev) => prev + 1)
  }

  const handleEditWarranty = (id) => {
    warrantyModalRef.current.open(id)
  }

  const handleDeleteWarranty = (id) => {
    let modal = deleteModalRef.current

    modal.open(id)

    modal.onSuccess(() => {
      handleDestroyWarranty(id)
    })
  }

  const handleDestroyWarranty = (id) => {
    Api.post("contractors/warranties/delete", { id }).then(() => {
      triggerRefresh()
    })
  }

  const handleActivateWarranty = (id) => {
    activateWarrantyModalRef.current.open(id)
  }

  const handleRenewWarranty = (id) => {
    Api.post("contractors/warranties/renew", { id }).then(() => {
      successModalRef.current.open()
      triggerRefresh()
    })
  }

  const handleDeactivareWarranty = (id) => {
    Api.post("contractors/warranties/deactivate", { id }).then(() => {
      successModalRef.current.open()
      triggerRefresh()
    })
  }

  const handleEditServicing = (id) => {
    servicingModalRef.current.open(id)
  }

  const handleDeleteServicing = (id) => {
    let modal = deleteModalRef.current

    modal.open(id)

    modal.onSuccess(() => {
      handleDestroyServicing(id)
    })
  }

  const handleDestroyServicing = (id) => {
    Api.delete(`contractors/appliance-servicing/${id}`).then(() => {
      triggerRefresh()
    })
  }

  const handleAdd = () => {
    let modal = warrantyModalRef.current
    if (modal) {
      modal.open()
      setActiveTab(1) // Switch to guarantees tab
    }
  }

  const handleAddServicing = () => {
    let modal = servicingModalRef.current
    if (modal) {
      modal.open()
      setActiveTab(2) // Switch to servicing tab
    }
  }

  return (
    <div className="wrapper">
      <Warranty ref={warrantyModalRef} onSave={triggerRefresh} />
      <WarrantyServicing ref={servicingModalRef} onSave={triggerRefresh} />

      <ActivateWarranty
        ref={activateWarrantyModalRef}
        onSave={triggerRefresh}
      />

      <Question
        ref={deleteModalRef}
        mainMessage={trans("headings.confirmDelete")}
        secondaryMessage={trans("subheadings.confirmDelete")}
      />

      <Success ref={successModalRef} />

      <div className="top-part">
        <div className="left">
          <h1 className="page-heading">{trans("headings.guarantees")}</h1>
          <p className="page-subheading">
            Lorem Ipsum е елементарен текст, използван в печатарската индустрия.
          </p>
        </div>
        <div
          className="right"
          style={{
            display: "flex",
          }}
        >
          <button className="button-add" onClick={handleAddServicing}>
            {trans("buttons.applianceServicing")}
          </button>
          <button
            className="button-add"
            onClick={handleAdd}
            style={{
              marginLeft: "8px",
            }}
          >
            {trans("labels.warranty")}
          </button>
        </div>
      </div>
      <Tabs
        value={activeTab}
        onChange={(e, newValue) => setActiveTab(newValue)}
        variant="scrollable"
        scrollButtons="auto"
        indicatorColor="primary"
        textColor="primary"
        aria-label="scrollable force tabs example"
      >
        <Tab value={1} label={trans("tabs.list")} />
        <Tab value={2} label={trans("tabs.forServicing")} />
      </Tabs>
      {activeTab === 1 && (
        <GuaranteesList
          handleEdit={handleEditWarranty}
          handleDelete={handleDeleteWarranty}
          handleActivate={handleActivateWarranty}
          handleRenew={handleRenewWarranty}
          handleDeactivate={handleDeactivareWarranty}
          refresh={refresh}
        />
      )}
      {activeTab === 2 && (
        <ServicingList
          handleEdit={handleEditServicing}
          handleDelete={handleDeleteServicing}
          refresh={refresh}
        />
      )}
    </div>
  )
}

export default forwardRef(Index)
